export class ServiceInvoiceLinesUpdateDto {
  InvoiceId: number;
  YourRef: string;
  MarkedWith: string;
  OrderDate: Date;
}
